import styled from "styled-components";

export const StyledAboutUsFirstSection = styled.div`
  width: 100%;
  padding: 44px clamp(22px, 9.583vw, 184px) clamp(64px, 5.333vw, 98px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: clamp(20px, 3.125vw, 60px);

  @media only screen and (max-width: 992px) {
    padding-left: 22px;
    padding-right: 22px;
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
  }
`;

export const StyledDescWrapper = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: flex-start;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const StyledImageWrapper = styled.div`
  width: 40%;
  height: 100%;

  .gatsby-image-wrapper {
    height: 100%;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    height: 300px;
  }
`;

export const StyledParseText = styled.div`
  font: 500 clamp(16px, 1.102vw, 20px) / 1.35em Poppins;
`;
